import { css } from 'styled-system/css';

export const miniStreamingStyle = {
	root: css.raw({
		display: 'none',
	}),
	rootShow: css.raw({
		position: 'relative',
		display: 'flex',
		margin: '3px',
		borderRadius: '3px',
		lgx: {
			display: 'none',
		},
		'& .video-view': {
			m: 0,
			_landscape: {
				width: '100%',
				height: 'inherit',
			},
		},
		'& .video-js': {
			width: '360px',
			height: '210px',
			mx: 'auto',
			_landscape: {
				width: 'auto',
				height: '100vh',
			},
		},
		'& .streaming-loading': {
			minH: '80px',
		},
		_landscape: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			m: 0,
			zIndex: 10000,
			'& iframe': {
				height: '100%',
			}
		}
	}),
	rootMini: css.raw({
		pt: 'calc( ( 210 / 375 ) / 2 * 100%)',
		md: {
			pt: '97px',
		},
		'& .video-js': {
			height: 'inherit',
			width: 'inherit',
		},
		_landscape: {
			'& iframe': {
				height: '100%',
				width: '100%',
			},
		}
	}),
	rootMiniPugin: css.raw({
		pt: 'calc( (( 202.6 / 360 ) / 2 * 100%) + 36px)',
		md: {
			pt: 'calc( (202.6px / 2) + 36px )',
		},
		'& .video-js': {
			height: 'inherit',
			width: 'inherit',
		},
	}),
	rootFloat: css.raw({
		position: 'fixed!',
		left: 0,
		right: 0,
		m: 0,
		zIndex: 1,
		boxShadow: '0 12px 12px {colors.blackOpacity.12}',
		top: 'calc(var(--header-height) + var(--page-header-height))',
		transition: 'top 200ms ease-in',
		md: {
			right: '10px',
			left: 'auto',
			width: '360px',
			_landscape: {
				right: 0,
				left: 0,
				top: 0,
				width: '100%',
				height: '100%',
			},
		},
		_dark: {
			boxShadow: '0 12px 12px {colors.blackOpacity.54}',
		},
		_mdBelow: {
			'&[data-is-top="true"]': {
				top: 'calc(var(--header-height) + var(--sports-menu-height) + var(--page-header-height))',
				_landscape: {
					top: 0!,
				},
			}
		}
	}),
	content: css.raw({
		width: '100%',
	}),
	contentMini: css.raw({
		display: 'flex',
		border: '1px solid {colors.black.5}',
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		rounded: '3px',
	}),
	contentFloat: css.raw({
		border: 'none',
	}),
	video: css.raw({
		pt: '30px',
		width: '100%',
		height: '100%',
		backgroundColor: 'black',
		_landscape: {
			p: 0,
		},
		'& .video-iframe': {
			_landscape: {
				width: 'auto',
				height: '100vh',
				'& iframe': {
					margin: '0 auto',
					width: 'calc((100vh - 36px)*1.78)',
				}
			}
		},
		'& .video-unactivated': {
			_landscape: {
				height: '100%',
			},
		}
	}),
	videoMini: css.raw({
		pt: 0,
		width: '50%',
		rounded: '3px 0 0 3px',
		overflow: 'hidden',
		md: {
			width: '173px',
			_landscape: {
				width: '100%', // iframe
			},
		},
		_landscape: {
			width: '100%',
		},
	}),
	view: css({
		position: 'relative',
		width: '100%',
		// mb: '9px',
		flex: 1,
		// height: 360px;
		display: 'flex',
		alignItems: 'center',
		padding: '1px',
		// height: '100%', // NOTE: 20240412 - 會影響 chatroom 的位置
		'& iframe, video': {
			height: '100%',
			maxH: '210px',
			mx: 'auto',
			_landscape: {
				maxH: '100vh',
			}
		},
		// '& .video-js': {
		// 	width: '360px',
		// 	height: '210px',
		// 	mx: 'auto',
		// }
	}),
	tools: css({
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		top: 0,
		zIndex: 1,
		p: '6px',
		gap: '3px',
		display: 'flex',
		alignItems: 'flex-end',
		bgGradient: 'to-b',
		gradientFrom: 'rgba(0, 0, 0, 0)',
		gradientTo: 'blackOpacity.54',
		pointerEvents: 'none',
		'& .btn--icon': {
			width: '20px',
			height: '20px',
			pointerEvents: 'auto',
			color: 'whiteOpacity.100',
		},
	}),
	videoInfo: css.raw({
		display: 'none',
	}),
	videoInfoActive: css.raw({
		position: 'absolute',
		display: 'block',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		zIndex: 2,
		p: '27px 12px',
		color: 'whiteOpacity.100',
		bgColor: 'blackOpacity.87',
		overflow: 'auto',
	}),
	info: css.raw({
		display: 'flex',
		flexDirection: 'row-reverse',
		justifyContent: 'flex-end',
		alignItems: 'center',
		padding: 0,
		width: '100%',
		height: '30px',
		bgColor: 'blackOpacity.87',
		position: 'absolute',
		top: 0,
		right: 0,
		color: 'whiteOpacity.100',
		'& .btn--icon': {
			width: '24px',
			height: '24px',
			color: 'currentColor',
			ml: '3px',
			'& .icon': {
				width: '18px',
				height: '18px',
			}
		},
		_landscape: {
			display: 'none',
		},
	}),
	infoMini: css.raw({
		display: 'flex',
		p: '0 6px',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '50%',
		height: '100%',
		bgColor: 'var(--other-lv4)',
		color: '{colors.black.1}',
		md: {
			width: 'calc(100% - 173px)',
		},
	}),
	status: css.raw({
		display: 'flex',
		alignItems: 'center',
		fontSize: 'sm',
		pr: '6px',
	}),
	statusMini: css.raw({
		borderBottom: '1px solid {colors.black.5}',
		pr: 0,
	}),
	score: css({
		color: 'secondary.500',
		fontWeight: '700',
		whiteSpace: 'nowrap',
	}),
	time: css.raw({
		color: 'white',
		ml: '3px',
		'& .match-timer .match-slide__item': {
			whiteSpace: 'normal',
		}
	}),
	timeMini: css.raw({
		color: '{colors.black.1}',
	}),
	videoButtons: css.raw({
		display: 'flex',
		gap: 0,
	}),
	videoButtonsMini: css.raw({
		position: 'absolute',
		bottom: 0,
		left: '6px',
		right: '6px',
		borderTop: '1px solid {colors.black.5}',
	}),
	videoButton: css.raw({
		'& .symbol': {
			width: '18px',
			height: '18px',
			bgColor: 'whiteOpacity.100',
		}
	}),
	videoButtonMini: css.raw({
		'& .symbol': {
			bgColor: '{colors.black.2}',
		}
	}),
	feature: css.raw({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	}),
	featureMini: css.raw({
		ml: 'auto',
		color: '{colors.black.2}',
	}),
	channel: css.raw({
		'& .dropdown__btn': {
			p: 0,
			bgColor: 'transparent',
			minH: '27px',
			_hover: {
				bgColor: 'transparent',
			}
		},
		'& .dropdown__current': {
			width: '24px',
			height: '24px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			color: 'whiteOpacity.100',
			ml: '3px',
			'& .icon': {
				width: '18px',
				height: '18px',
			}
		},
		'& .dropdown__item[data-selected=true]': {
			bgColor: 'transparent',
		}
	}),
	channelMini: css.raw({
		'& .dropdown__current': {
			color: '{colors.black.2}',
		},
	}),
	channelActive: css.raw({
		'& .dropdown__current': {
			color: 'secondary.500',
		},
	}),
	option: css.raw({
		display: 'flex',
		justifyContent: 'space-between',
		alignContent: 'center',
		width: '100%',
		'& .icon': {
			display: 'none',
		}
	}),
	optionActive: css.raw({
		color: 'secondary.500',
		'& .icon': {
			display: 'block',
			width: '24px',
			height: '24px',
		},
	}),
	match: css.raw({
		flex: 1,
		display: 'flex',
		ml: '12px',
		wordBreak: 'break-all',
	}),
	matchMini: css.raw({
		flexDirection: 'column',
		gap: '3px',
		ml: 0,
		pt: '3px',
		pb: '27px',
	}),
	team: css.raw({
		display: 'flex',
		alignItems: 'center',
		maxW: '50%',
	}),
	teamMini: css.raw({
		maxW: '100%',
	}),
	teamName: css({
		WebkitLineClamp: 1,
	}),
	vs: css({
		flex: '0 0 auto',
		mx: '3px',
	}),
};
